const normalize = value =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase();

const sortTree = nodes =>
  nodes
    .sort((left, right) => {
      if (left.type !== right.type) return left.type === 'folder' ? -1 : 1;
      return left.label.localeCompare(right.label);
    })
    .map(node =>
      node.type === 'folder'
        ? { ...node, children: sortTree(node.children) }
        : node
    );

const buildTree = (items, partsFor, leafFor) => {
  const root = [];

  items.forEach(item => {
    const parts = partsFor(item);
    const label = parts.pop() || 'Sin nombre';
    const path = [];
    let children = root;

    parts.forEach(part => {
      path.push(part);
      const key = normalize(part);
      let folder = children.find(
        node => node.type === 'folder' && normalize(node.label) === key
      );
      if (!folder) {
        folder = {
          id: `folder:${path.map(normalize).join('/')}`,
          type: 'folder',
          label: part,
          children: [],
        };
        children.push(folder);
      }
      children = folder.children;
    });

    children.push({ label, ...leafFor(item) });
  });

  return sortTree(root);
};

export const buildCustomViewTree = views =>
  buildTree(
    views,
    view =>
      String(view.name || '')
        .split('/')
        .map(part => part.trim())
        .filter(Boolean),
    view => ({ id: `view:${view.id}`, type: 'view', viewId: view.id })
  );

export const buildLabelTree = labels =>
  buildTree(
    labels,
    label => {
      const title = String(label.title || '');
      // ponytail: current labels use the first hyphen as their two-level path;
      // use -- when deeper or unambiguous nesting becomes necessary.
      const parts = title.includes('--')
        ? title.split('--')
        : title.split(/-(.*)/s).slice(0, 2);
      return parts.map(part => part.trim()).filter(Boolean);
    },
    label => ({
      id: `label:${label.id}`,
      type: 'label',
      color: label.color,
      labelTitle: label.title,
    })
  );

export const filterCustomViewTree = (nodes, query) => {
  const needle = normalize(query).trim();
  if (!needle) return nodes;

  return nodes.flatMap(node => {
    if (normalize(node.label).includes(needle)) return [node];
    if (node.type !== 'folder') return [];
    const children = filterCustomViewTree(node.children, needle);
    return children.length ? [{ ...node, children }] : [];
  });
};
